var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3131 18.0404C14.7314 18.0404 18.3131 14.4587 18.3131 10.0404C18.3131 5.62213 14.7314 2.04041 10.3131 2.04041C5.89483 2.04041 2.31311 5.62213 2.31311 10.0404C2.31311 14.4587 5.89483 18.0404 10.3131 18.0404ZM10.3131 7.41692C11.0735 7.41692 11.6899 6.80053 11.6899 6.04018C11.6899 5.27984 11.0735 4.66345 10.3131 4.66345C9.55278 4.66345 8.9364 5.27984 8.9364 6.04018C8.9364 6.80053 9.55278 7.41692 10.3131 7.41692ZM9.31873 9.28845V15.8876H11.3187V9.28845H9.31873Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoWhite);
export default __webpack_public_path__ + "static/media/info-white.a266d1ebed580afc3450ef2a05117f19.svg";
export { ForwardRef as ReactComponent };